import { render, staticRenderFns } from "./kanban-details.vue?vue&type=template&id=c16b21ec&scoped=true&"
import script from "./kanban-details.vue?vue&type=script&lang=js&"
export * from "./kanban-details.vue?vue&type=script&lang=js&"
import style0 from "./kanban-details.vue?vue&type=style&index=0&id=c16b21ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16b21ec",
  null
  
)

export default component.exports